// Static version tracker for the SPY 20/200 EMA Strategy (backend/cmd/spyemabacktest).
// Same pattern/conventions as StrategyVersionTracker.js (SPY RSI Strategy) -
// manually maintained, updated in the same turn a rule changes and is
// re-backtested. See that file's header comment for the extend-in-place /
// new-row / replace-row rules; identical here.
const CONDITIONS = [
  { text: 'Setup: 20 EMA > 200 EMA on the SPY 5-min chart', addedAt: '2026-07-14' },
  { text: 'Entry: a 5-min candle closes above the 20 EMA while setup holds → buy the 0DTE call at the strike NEAREST spot', addedAt: '2026-07-14' },
  { text: 'Contract used is the SAME day’s (0DTE) expiry', addedAt: '2026-07-14' },
  { text: 'No new entries after 2:30 PM ET; forced exit by 3:30 PM ET if nothing else fired', addedAt: '2026-07-14' },
  { text: 'One open position at a time; re-enters immediately once flat if setup+signal still hold (no "fresh cross" required)', addedAt: '2026-07-14' },
  { text: 'Exit (TP): dollar distance (20EMA-200EMA) reaches >= 1.5x the distance measured AT ENTRY', addedAt: '2026-07-14' },
  { text: 'Exit (SL): fixed -50% from entry', addedAt: '2026-07-14' },
  { text: 'No trailing stop', addedAt: '2026-07-14' },
  { text: 'Starting budget $500 as one running total (not a per-trade cap); an unaffordable signal is skipped, not the whole day', addedAt: '2026-07-14' },
  { text: '$7/contract flat round-trip cost', addedAt: '2026-07-14' },
];

const VERSIONS = [
  {
    name: 'Original Strategy',
    note: '2026-07-14 — first draft as specified',
    has: new Set([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
  },
];

export default function SpyEmaStrategyVersionTracker() {
  return (
    <div className="bg-gray-900 rounded-2xl p-5 mb-5">
      <div className="flex items-center gap-3 mb-1 flex-wrap">
        <span className="text-xs font-bold px-3 py-1.5 rounded border"
          style={{ backgroundColor: '#111827', color: '#e5e7eb', borderColor: '#374151' }}>
          SPY 20/200 EMA Strategy — Version Tracker
        </span>
      </div>
      <div className="text-xs text-gray-500 mb-3">
        Manually maintained record of which rules each backtest version ran with. Green check = rule active in that version, red X = not active.
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-xs" style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr className="text-gray-500 border-b" style={{ borderColor: '#1f2937' }}>
              <th className="py-2 pr-3 text-left font-medium" style={{ width: 36 }}>#</th>
              <th className="py-2 pr-3 text-left font-medium">Condition</th>
              {VERSIONS.map((v) => (
                <th key={v.name} className="py-2 px-3 text-center font-medium" style={{ minWidth: 120 }}>
                  <div className="text-gray-300">{v.name}</div>
                  <div className="text-[10px] font-normal text-gray-600 normal-case">{v.note}</div>
                </th>
              ))}
              <th className="py-2 pl-3 text-right font-medium" style={{ minWidth: 90 }}>Added</th>
            </tr>
          </thead>
          <tbody>
            {CONDITIONS.map((cond, i) => (
              <tr key={i} className="border-b" style={{ borderColor: '#1f2937' }}>
                <td className="py-2 pr-3 text-gray-500 font-mono">{i + 1}</td>
                <td className="py-2 pr-3 text-gray-300">{cond.text}</td>
                {VERSIONS.map((v) => (
                  <td key={v.name} className="py-2 px-3 text-center font-bold" style={{ color: v.has.has(i) ? '#22c55e' : '#ef4444' }}>
                    {v.has.has(i) ? '✓' : '✗'}
                  </td>
                ))}
                <td className="py-2 pl-3 text-right text-gray-500 font-mono">{cond.addedAt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
